import React, { useEffect, useState } from "react";
import { Snackbar, Alert } from "@mui/material";
import { Subject } from "rxjs";

// The Main Subject/Stream to be listened on.
const mainSubject = new Subject<MessageData>();
// This function is used to publish data to the Subject via next().
export type MessageData = {
  message: string;
  variant: "success" | "error" | "warning" | "info" | null;
};
export const publishMessage = (data: MessageData) => mainSubject.next(data);

export const Message: React.FC = () => {
  const [data, setData] = useState<MessageData>({
    message: "",
    variant: null,
  });

  useEffect(() => {
    const subscription = mainSubject.subscribe((messageData: MessageData) => {
      setData(messageData);
    });
    return () => subscription.unsubscribe();
  }, []);

  const handleClose = () => {
    setData({
      message: "",
      variant: null,
    });
  };

  return data.variant ? (
    <Snackbar
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      style={{ top: "56px" }}
      open={!!data.message}
      autoHideDuration={5000}
      onClose={handleClose}
      onClick={handleClose}
    >
      <Alert
        onClose={handleClose}
        severity={data.variant}
        sx={{ width: "100%" }}
      >
        {data.message}
      </Alert>
    </Snackbar>
  ) : null;
};
